import queryString from 'query-string'

export const BASE_PATH = '/books'

export const BOOKS_REQUEST_PARAMS = {
  filter: 'filter',
}

export const booksUsageStatisticsPath = () => `${BASE_PATH}/usage-statistics`

export const booksLibraryPath = (filter?: string) => {
  const queryParams: {[key: string]: string} = {}
  if (filter) {
    queryParams[BOOKS_REQUEST_PARAMS.filter] = filter
  }
  const data = queryString.stringify(queryParams)

  return `${BASE_PATH}/library${data ? `?${data}` : ''}`
}
